import React, { useEffect, useState } from "react";
import { Upload, message } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import "./ProfilePictureUpload.css";

function ProfilePictureUpload(props) {
  const [avatarBase64, setAvatarBase64] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (info) => {
    setAvatarBase64("");
    setLoading(true);
    props.imageFile(info.file); // Pass the file object directly
    setTimeout(() => {
      const reader = new FileReader();
      reader.onload = (e) => {
        setAvatarBase64(e.target.result);
        setLoading(false);
      };
      reader.readAsDataURL(info.file);
    }, 500);
  };

  //handle the captured image from camera
  useEffect(() => {
    if (props.capturedImage) {
      setAvatarBase64(props.capturedImage);
    }
  }, [props.capturedImage]);

  // for regular image uploads
  useEffect(() => {
    if (props.imageUrl) {
      setAvatarBase64(props.imageUrl);
    }
  }, [props.imageUrl]);

  const uploadButton = (
    <div className="custom-upload-button" style={{ width: 100, height: 250 }}>
      {loading ? (
        <LoadingOutlined style={{ marginTop: 100 }} />
      ) : (
        <PlusOutlined style={{ marginTop: 100 }} />
      )}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <Upload
      name="avatar"
      listType="picture-card"
      className="avatar-uploader"
      showUploadList={false}
      beforeUpload={() => false}
      onChange={handleChange}
      accept="image/*"
    >
      {avatarBase64 ? (
        <img src={avatarBase64} alt="avatar" style={{ width: "100%" }} />
      ) : (
        uploadButton
      )}
    </Upload>
  );
}

export default ProfilePictureUpload;
